import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { BaseComponent } from './views/layout/base/base.component';
import { AuthGuard } from './core/authentication/auth.guard';
import { ErrorPageComponent } from './pixeltrade/error/error-page.component';


const routes: Routes = [
  { path: 'account', loadChildren: () => import('./core/account/account.module').then(m => m.AccountModule) },
  {
    path: '',
    component: BaseComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'dashboard',
        loadChildren: () => import('./pixeltrade/dashboard/dashboard.module').then(m => m.DashboardModule)
      },
      {
        path: 'strategies',
        loadChildren: () => import('./pixeltrade/strategies/strategies.module').then(m => m.StartegiesModule)
      },
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' }

    ]
  },
  {
    path: 'error',
    component: ErrorPageComponent,
    data: {
      type: 404,
      title: 'Page Not Found',
      desc: 'Oopps!! The page you were looking for doesn\'t exist.'
    }
  },
  {
    path: 'error/:type',
    component: ErrorPageComponent
  },
  { path: '**', redirectTo: 'error', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'top' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
